import React from "react";
import { Grid } from "@mui/material";
import LabeledText from "../../Widgets/LabeledText";
import { TreatmentVariablesFormValues } from "./interface";

interface ViewFieldsProps {
  formValues: TreatmentVariablesFormValues;
}

export const ViewFields: React.FC<ViewFieldsProps> = ({ formValues }) => {
  return (
    <Grid container sx={{ rowGap: "24px" }}>
      <LabeledText label="Spiritual factors" value={formValues.spiritualFactors} />
      <LabeledText label="Cultural factors" value={formValues.culturalFactors} />
      <LabeledText label="Legal factors" value={formValues.legalFactors} />
      <LabeledText label="Linguistic factors" value={formValues.linguisticFactors} />
      <LabeledText label="Community resources" value={formValues.communityResources} />
    </Grid>
  );
};

export default ViewFields;
